const companimg = {
    company_img : "Images/Comp_page/companypage.png"
 };
 export default companimg;